"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../object/isNil"));

var setImageSmoothing = function setImageSmoothing(context) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if ((0, _isNil["default"])(context)) return; // Set image smoothing to false to prevent weird anti-aliasing

  context.mozImageSmoothingEnabled = value;
  context.webkitImageSmoothingEnabled = value;
  context.msImageSmoothingEnabled = value;
  context.imageSmoothingEnabled = value;
};

var _default = setImageSmoothing;
exports["default"] = _default;